<script setup>
import { ref, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Button from 'primevue/button'
import Message from 'primevue/message'

const auth = useAuthStore()
const router = useRouter()
const route = useRoute()

const form = reactive({
  email: '',
  password: '',
})

const submitting = ref(false)
const localError = ref('')

async function submit() {
  localError.value = ''
  if (!form.email || !form.password) {
    localError.value = 'Укажите e-mail и пароль'
    return
  }
  submitting.value = true
  const ok = await auth.login({ email: form.email, password: form.password })
  submitting.value = false
  if (ok) {
    const redirect = typeof route.query.redirect === 'string' ? route.query.redirect : null
    router.push(redirect && redirect !== '/login' ? redirect : { name: 'scrolls' })
  }
}
</script>

<template>
  <div class="login">
    <form class="login__card" @submit.prevent="submit">
      <div class="login__brand">
        <i class="pi pi-shield" />
        <span>Росфинмониторинг</span>
      </div>
      <h2 class="login__title">Вход в админку</h2>

      <div class="login__field">
        <label for="email">E-mail</label>
        <InputText
          id="email"
          v-model="form.email"
          autocomplete="username"
          autofocus
          :disabled="submitting"
          fluid
        />
      </div>

      <div class="login__field">
        <label for="password">Пароль</label>
        <Password
          id="password"
          v-model="form.password"
          :feedback="false"
          toggle-mask
          autocomplete="current-password"
          :disabled="submitting"
          fluid
          input-class="w-full"
        />
      </div>

      <Message
        v-if="auth.error || localError"
        severity="error"
        :closable="false"
        class="login__error"
      >
        {{ localError || auth.error }}
      </Message>

      <Button
        type="submit"
        label="Войти"
        icon="pi pi-sign-in"
        :loading="submitting"
        class="login__submit"
        fluid
      />
    </form>
  </div>
</template>

<style scoped>
.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%);
  padding: 1rem;
}

.login__card {
  background: #fff;
  width: 100%;
  max-width: 380px;
  padding: 2rem;
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.login__brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--p-primary-color, #3b82f6);
  font-weight: 600;
}

.login__title {
  margin: 0 0 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
}

.login__field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.login__field label {
  font-size: 0.85rem;
  color: #4b5563;
}

:deep(.p-password) {
  width: 100%;
}
:deep(.p-password input) {
  width: 100%;
}

.login__error {
  margin: 0;
}

.login__submit {
  margin-top: 0.5rem;
}
</style>
